<template>

    <v-modal title="Delete Block">
        <template #body>
            <v-alert :message="error" />
            <p>Are you sure you want to delete the block:<br>{{ block.name }}</p>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" btn-style="danger" :loading="loading" @click.native="deleteBlock">Delete Block</v-button>
        </template>
    </v-modal>

</template>

<script>

import BlockApi from '@api/BlockApi'

export default {

    props: {
        block: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            error: null,
        }
    },

    methods: {

        deleteBlock() {
            this.loading = true;
            BlockApi.deleteBlock(this.block.id)
                .then((response) => {
                    this.loading = false;
                    this.$emit('deleted');
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
